import { render, staticRenderFns } from "./secondOrderDetailPage.vue?vue&type=template&id=abb55b7a&scoped=true&"
import script from "./secondOrderDetailPage.vue?vue&type=script&lang=js&"
export * from "./secondOrderDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./secondOrderDetailPage.vue?vue&type=style&index=0&id=abb55b7a&prod&lang=scss&scoped=true&"
import style1 from "./secondOrderDetailPage.vue?vue&type=style&index=1&id=abb55b7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb55b7a",
  null
  
)

export default component.exports